/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import { AdviceSeverities, AdviceTypes } from '../../consts';
import { Endpoint } from '../index';
import { z, ZodTypes } from '../zod';

const Params = z.strictObject({
  organizationId: ZodTypes.Id,
  projectId: ZodTypes.Id,
  serviceId: ZodTypes.Id,
});

export const GetAdvice = {
  id: 'advice.get',
  tag: 'Advice',
  summary: 'Get service advice',
  description: 'Retrieve advice for a service',
  method: 'get',
  flags: { isAuthorized: true },
  route: (params: z.infer<typeof Params>) =>
    `/organization/${params.organizationId}/project/${params.projectId}/cluster/${params.serviceId}/advice`,
  request: {
    params: Params,
  },
  response: {
    200: {
      description: 'successful',
      content: {
        'application/json': {
          schema: z.array(
            z.strictObject({
              id: z.string(),
              run: z.strictObject({
                id: z.string(),
                timestamp: ZodTypes.Timestamp,
              }),
              object: z.string().optional(),
              subObject: z.string().optional(),
              type: z.enum(AdviceTypes),
              severity: z.enum(AdviceSeverities),
              info: z.string(),
              text: z.string().optional(),
              detail: z.string().optional(),
              script: z.string().optional(),
              furtherReading: z.string().optional(),
            }),
          ),
        },
      },
    },
  },
} as const satisfies Endpoint;
